/**
* Created by vouill on 2018-12-22.
*/

<template>
  <div class="c-container v-content-container">
    <ConseillerItem
      v-for="data in conseilItems"
      :data="data"/>
  </div>
</template>

<style scoped lang="scss">
.c-container {
  margin-top: 3em;
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 800px) {
  .c-container {
    margin-top: 0;
    justify-content: center;

  }
}
</style>
<script>
import { hoc } from "vuex-api";
import { contentFullApi } from "../../utils/contentful";
import ConseillerItem from "./conseiller-item";

export default {
  name: "Conseiller",
  props: {},
  components: { ConseillerItem, hoc },
  mounted() {
    contentFullApi
      .getEntries({ content_type: "conseillerItem" })
      .then(d => (this.conseilItems = d.items));
  },
  data() {
    return { conseilItems: [] };
  }
};
</script>
